import { InjectionToken } from "@angular/core";

import { ClaimPage } from "../models/claim-page";
import { TRoutePage } from "../services/route-service/models/route-page";

export const ROUTE_PAGE = new InjectionToken<TRoutePage | null>('');

// De autorisatie-pagina (claim-eenheid) van een autoriseerbaar blad: élke lijst/tablist en élke
// sectie-page (details/edit/compact) provide't dit token in zijn eigen injector, i.p.v. de
// claimPage via inputs of via de container te laten lopen. Past in het token-idioom van ROUTE_PAGE.
export const CLAIM_PAGE = new InjectionToken<ClaimPage>('CLAIM_PAGE');

// Aparte token voor de vroege details-auth-registratie die een tab-page-container zelf provide't
// (zie _TabPageRouteComponent._ngOnInit / project_tabfooter_edit_button_claimpage_fix). Bewust NIET
// hergebruikt via CLAIM_PAGE: de xxxEditComponent-varianten resolven CLAIM_PAGE zelf via een
// skipSelf-useFactory om in create-modus terug te vallen op de create-container's claim (zie
// *CreatePageRouteComponent). Zou de tab-page-container óók CLAIM_PAGE=xxxDetails provide'n, dan vindt
// die skipSelf-lookup in gewone (niet-create) edit-modus altijd de xxxDetails-claim van de container
// i.p.v. door te vallen op de eigen xxxEdit-claim — de save-knop autoriseert dan tegen de verkeerde
// claim-pagina. Vandaar dit losse kanaal, uitsluitend voor de container → route-component-registratie.
export const CLAIM_PAGE_DETAILS = new InjectionToken<ClaimPage>('CLAIM_PAGE_DETAILS');